// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function CardV5(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: props.children,
                    className: "flex grow flex-col p-5"
                  }),
              className: TailwindMerge.twMerge([
                    "rounded border bg-white shadow-sm border-zinc-300 flex flex-row md:flex-col",
                    className
                  ])
            });
}

var make = CardV5;

exports.make = make;
/* tailwind-merge Not a pure module */
